import { createI18n } from 'vue-i18n'
import type { I18n } from 'vue-i18n'
import { getCurrentLanguage } from '@eureka/language-tool'
import cnMessages from './cn.json'
import enMessages from './en.json'
import jpMessages from './jp.json'
import twMessages from './tw.json'

const localMessages = {
    cn: cnMessages,
    en: enMessages,
    jp: jpMessages,
    tw: twMessages,
}

export function createI18nInstance(locale?: string): I18n {
    // 使用 @eureka/language-tool 的 getCurrentLanguage 获取语言
    // 该函数会按优先级判断：Cookie(---uniform-setting-locale) > 域名识别 > 默认英文
    locale = locale || getCurrentLanguage()

    const instance = createI18n({
        legacy: false,  // Use Composition API mode
        locale,
        fallbackLocale: 'cn',
        globalInjection: true,
        missingWarn: false,
        fallbackWarn: false,
    })

    const globalOrWindow = (instance as any).global || (instance as any).window;

    if (!globalOrWindow) {
        throw new Error('Failed to initialize vue-i18n: global/window property is missing.');
    }

    // Map window to global for compatibility
    if ((instance as any).window && !(instance as any).global) {
        (instance as any).global = (instance as any).window;
    }

    // Load local messages for all locales
    Object.keys(localMessages).forEach(lang => {
        const messages = localMessages[lang as keyof typeof localMessages];
        if (messages) {
            globalOrWindow.mergeLocaleMessage(lang, messages);
        }
    });

    return instance;
}

export const i18n = createI18nInstance()

// Export function to update locale
export function updateLocale(newLocale: string) {
    const globalOrWindow = (i18n as any).global || (i18n as any).window;
    if (globalOrWindow) {
        globalOrWindow.locale.value = newLocale;
    }
}
